import { UploadIcon } from '@heroicons/react/outline'
import React from 'react'
import { InputFile } from './input.ui'


export const ImageUi = ({ img, cloud, name, height = '150px', width = '100%', error, title = '', onChange, clickable = true, classes='', rounded = 'rounded-md', alt='image...' }) => {
  if (img || cloud) {
    return (
      <label style={{width: width, height: height}}  className={` ${rounded} ${classes} ${clickable && 'cursor-pointer'} hover:bg-gray-100 border-2 border-gray-300 border-dashed`}>
          <img style={{height: height, width: width}}  src={img ? img : cloud} alt={alt} className={` ${rounded} object-cover `} />
        <InputFile onChange={onChange} name={name} />
      </label>
    )
  }
  return (
    <label style={{width: width, height: height}} className={` ${rounded} ${classes} ${clickable && 'cursor-pointer'} hover:bg-gray-100 border-2 border-gray-300 border-dashed`}>
      <div className="flex flex-col items-center justify-center pt-5">
        <UploadIcon className="mx-auto h-12 w-12 text-gray-400" />
        {
          error
            ? <p className="text-xs text-red-400 flex items-center justify-center">erreur</p>
            : <div>
              <p className="text-xs text-gray-400 flex items-center justify-center">max 3MB</p>
              <p className="text-xs text-gray-400 flex items-center justify-center">{title}</p>
            </div>
        }
        {
          clickable &&
          <InputFile onChange={onChange} name={name} />
        }
      </div>
    </label>
  )
}
